<template>
  <section v-if="promoBanner.active" id="home-promo-banner" :style="{backgroundColor: promoBanner.colorBackground}">
    <div class="home-promo-banner">
      <div class="home-promo-banner__layout">
        <a v-if="promoBanner.externalUrl" class="home-promo-banner__link" :href="promoBanner.externalUrl"
           target="_blank">
          <div v-if="promoBanner.title.length" class="home-promo-banner__heading">
            {{ promoBanner.title }}
          </div>
        </a>
        <div v-else-if="promoBanner.title.length && !promoBanner.externalUrl" class="home-promo-banner__heading">
          {{ promoBanner.title }}
        </div>
        <div class="home-promo-banner__image">
          <a v-if="promoBanner.externalUrl" class="home-promo-banner__link" :href="promoBanner.externalUrl"
             target="_blank">
            <img :src="$router.options.imagePath + promoBanner.mediaUrl" :alt="promoBanner.title"/>
          </a>
          <img v-else :src="$router.options.imagePath + promoBanner.mediaUrl" :alt="promoBanner.title"/>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";

export default {
  name: "HomePromoBanner",
  data() {
    return {
      promoBanner: {
        active: false,
        externalUrl: null,
        colorBackground: '#e3e2de',
        title: '',
        mediaUrl: ''
      }
    }
  },
  mounted() {
    this.getHomePromoBannerData()
  },
  methods: {
    getHomePromoBannerData() {
      axios.get(this.$router.options.api + '/front/front-page-promo-banner')
          .then((response) => {
            this.promoBanner.active = response.data.active;
            this.promoBanner.externalUrl = response.data.externalUrl;
            this.promoBanner.colorBackground = response.data.colorBackground;
            this.promoBanner.title = response.data.title;
            this.promoBanner.mediaUrl = response.data.mediaUrl;
          })
          .catch(error => console.error(error))
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/sass/abstracts/variables";

#home-promo-banner {
  padding: 40px 0;
  @include media-breakpoint-down(lg) {
    padding: 20px 0;
  }
}

.home-promo-banner {
  &__link {
    color: $c_black;

    &:hover {
      color: $c_base;
    }
  }

  &__heading {
    @include font-18-md();
    margin-bottom: 45px;
  }

  &__image {
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  &__layout {

  }
}
</style>
